import React from "react";
import { Box, Typography, LinearProgress, Tooltip } from "@mui/material";
import LabelValueDisplay from "../LabelValue/LabelValueDisplay";
import SettingIcon from "../../../../../asset/image/setting2.svg";
import outlined_sim_icon from "../../../../../asset/image/outlined_sim_icon.svg";
import star_icon_new from "../../../../../asset/image/star_icon_new.svg";
import no_sim_icon from "../../../../../asset/image/no_sim.svg";
import activeLockedSim from "../../../../../asset/image/activeLockedSim.svg";
import standbyLockedSim from "../../../../../asset/image/standbyLockedSim.svg";
import StatusButton from "./StatusButton";
import './simCard.css'

interface SimCardProps {
    status: "Active" | "Standby" | "No SIM";
    simLabel: string;
    provider: string;
    iccid: string;
    apn: string;
    usage: number;
    limit: number;
    uptime?: string;
    color?: string;
    isPriority?: boolean;
    isEmpty?: boolean;
    isLocked?: boolean;
    onClick?: () => void;
    onSimSettingClick?: (e: React.MouseEvent) => void;
    modemConnected?: boolean;
}

const SimCard: React.FC<SimCardProps> = ({
    status,
    simLabel,
    provider,
    iccid,
    apn,
    usage,
    limit,
    uptime,
    color,
    isPriority,
    onClick,
    onSimSettingClick,
    isEmpty,
    isLocked,
    modemConnected
}) => {
    const isActive = status === "Active";

    const handleCardClick = () => {
        if (!isActive && !isEmpty) {
            onClick?.();
        }
    };

    return (
        <Box
            onClick={handleCardClick}
            sx={{
                border: `1px solid ${modemConnected && isActive ? "rgba(95, 95, 255, 1)" : "#E0E0E0"}`,
                borderRadius: "4px",
                padding: '6px',
                background: "#fff",
                minHeight: '120px',
                cursor: !isActive && !isEmpty && !isLocked ? "pointer" : "default"
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'space-between', gap: 1 }}>
                {
                    isLocked ?
                        <StatusButton
                            icon={isActive ? <Tooltip title={<span style={{ fontSize: "12px" }}>SIM Locked</span>}><img className="sim-locked-icon" src={activeLockedSim} /></Tooltip> : <Tooltip title={<span style={{ fontSize: "12px" }}>SIM Locked</span>}><img src={standbyLockedSim} /></Tooltip>}
                            label={""}
                            isActive={isActive}
                        />
                        :
                        <StatusButton
                            label={isEmpty ? "No Sim" : isActive ? "Active" : "Standby"}
                            isActive={isActive}
                        />
                }

                {isPriority && <img src={star_icon_new} alt="Priority SIM" />}
                <div className="display-center-align-gap" style={{ gap: "2px" }}>
                    <img src={outlined_sim_icon} alt="" />
                    <span className="value-text-controller">{simLabel}</span>
                </div>
                {isEmpty ? null :
                    <div className="display-center-align-gap" style={{ gap: "2px" }}>
                        <img src={outlined_sim_icon} alt="" />
                        <span className="value-text-controller">{provider}</span>
                        <Tooltip title={<span style={{ fontSize: "12px" }}>SIM Setting</span>}><img className="active-link" style={{ marginLeft: "8px" }} src={SettingIcon} alt="" onClick={(e) => { e.stopPropagation(); onSimSettingClick?.(e); }} /></Tooltip>
                    </div>
                }


            </Box>

            {
                isEmpty ?
                    <Box sx={{ mt: 2 }} style={{ textAlign: 'center' }}>
                        <img src={no_sim_icon} alt="No SIM" />
                        <Typography variant="body2" color="text.secondary">
                            {/* Insert another SIM to activate this slot */}
                            No SIM Detected
                        </Typography>
                    </Box>
                    :
                    <Box sx={{ mt: 2 }}>
                        <LabelValueDisplay
                            label="ICCID"
                            value={iccid}
                            flexDirection='row'
                        />
                        <LabelValueDisplay
                            label="APN"
                            value={apn}
                            flexDirection='row'
                        />
                    </Box>

            }


        </Box>
    );
};

export default SimCard;